module.exports = __webpack_public_path__ + "img/bread-account-center-flows.6a1731ef.png";